// extracted by mini-css-extract-plugin
module.exports = {"container":"quick-add-multi-modal-form_container___K4gY","table":"quick-add-multi-modal-form_table__108jO"};